import api from './api';

const officeTransactionService = {
    // Create new office transaction
    async createTransaction(data) {
        const response = await api.post('/office-transactions', data);
        return response.data;
    },

    // Get all office transactions with filters and pagination
    async getTransactions(filters = {}, page = 1, limit = 20) {
        const params = new URLSearchParams();

        if (filters.fromDate) params.append('fromDate', filters.fromDate);
        if (filters.toDate) params.append('toDate', filters.toDate);
        if (filters.productName) params.append('productName', filters.productName);
        if (filters.officeLocation) params.append('officeLocation', filters.officeLocation);

        params.append('page', String(page));
        params.append('limit', String(limit));

        const response = await api.get(`/office-transactions?${params.toString()}`);
        return response.data;
    },

    // Get single office transaction by ID
    async getTransactionById(id) {
        const response = await api.get(`/office-transactions/${id}`);
        return response.data;
    },

    // Update office transaction
    async updateTransaction(id, data) {
        const response = await api.put(`/office-transactions/${id}`, data);
        return response.data;
    },

    // Delete office transaction
    async deleteTransaction(id) {
        const response = await api.delete(`/office-transactions/${id}`);
        return response.data;
    },

    // Get office locations for dropdown
    async getOfficeLocations() {
        const response = await api.get('/office-transactions/office-locations');
        return response.data;
    },

    // Get product names for dropdown
    async getProductNames() {
        const response = await api.get('/office-transactions/product-names');
        return response.data;
    },

    // Get summary data for chairman dashboard
    async getSummary(filters = {}) {
        const params = new URLSearchParams();

        if (filters.fromDate) params.append('fromDate', filters.fromDate);
        if (filters.toDate) params.append('toDate', filters.toDate);

        const response = await api.get(`/office-transactions/summary?${params.toString()}`);
        return response.data;
    }
};

export default officeTransactionService;